var ezdia;
(function (ezdia) {
    var SINGLECHOICE_EDITABLE = 'SINGLECHOICE_EDITABLE';
    var SINGLECHOICE_NON_EDITABLE = 'SINGLECHOICE_NON_EDITABLE';
    var validateKey;
    var NAME = 'inputList';
    var TYPE = 'inputList';
    var DATA_TYPE = "ez." + TYPE;
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var DEFAULT = {
        mode: 'list',
        rowSelector: '[data-row="groupFields"]',
        addBtnSelector: '[data-btn="add"]',
        removeBtnSelector: '[data-btn="remove"]',
        editBtnSelector: '[data-btn="edit"]',
        inputsSelector: '[data-path^="groupFields"]',
        inputContainer: '[data-container="groupfield"]',
        // inputFields: 'group-fields-inputs',
        trigger: 'click',
        editable: true,
        storageType: false,
        count: 0,
        fields: null,
        preview: false,
        removeDisabled: false
    };
    function getAttrMetaReqData(attrMeta, rowData) {
        var query = attrMeta.query;
        var querydata = {};
        var data = {};
        var _a = __read(ezdia.util.getSelectedIdColData('sys_category_id'), 1), ezCategoryId = _a[0];
        rowData.forEach(function (row) {
            query.forEach(function (qname) {
                if (!querydata[qname]) {
                    querydata[qname] = [];
                }
                if (row[qname]) {
                    querydata[qname].push(row[qname]);
                }
            });
        });
        Object.entries(querydata).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], val = _b[1];
            data[key] = val.join(',');
        });
        return __assign({ ezCategoryId: ezCategoryId }, data);
    }
    var InputList = /** @class */ (function () {
        function InputList(elem, options) {
            this.elem = elem;
            this.init(options);
        }
        Object.defineProperty(InputList.prototype, "Defaults", {
            get: function () {
                return DEFAULT;
            },
            enumerable: false,
            configurable: true
        });
        InputList.prototype.refresh = function (data) {
            var options = this.options;
            var container = this.$container.find(options.inputContainer);
            var dataString = data;
            if (typeof data !== 'string') {
                dataString = JSON.stringify(data);
            }
            this.$elem.val(dataString);
            container.remove();
            if (this.type === 'inputList') {
                this.$container.find(".list-rearrange-btn").remove();
            }
            this.stringData = data;
            this.render(true);
            this.onOffAddBtn();
        };
        InputList.prototype.destroy = function () {
            // clearTimeout(this.timeout);
            this.$elem.removeData("ez." + this.type);
            this.$container.off("." + this.type);
        };
        InputList.prototype.getOptions = function (options) {
            return __assign(__assign(__assign({}, DEFAULT), this.$elem.data()), options);
        };
        InputList.prototype.setMarkupTemplates = function () {
            var mode = this.options.mode.toLowerCase();
            var template;
            var rowTemplate;
            if (this.options.template) {
                template = this.options.template;
            }
            else if (mode === 'list') {
                template = ezdia.templates.inputList.listTemplate;
            }
            else {
                template = ezdia.templates.inputList.groupTemplate;
            }
            if (this.options.rowTemplate) {
                rowTemplate = this.options.rowTemplate;
            }
            else if (mode === 'list') {
                rowTemplate = ezdia.templates.inputList.listItemTemplate;
            }
            else {
                rowTemplate = ezdia.templates.inputList.groupItemTemplate;
            }
            this.template = template;
            this.rowTemplate = rowTemplate;
        };
        InputList.prototype.init = function (options) {
            this.type = TYPE;
            this.$elem = $(this.elem);
            this.options = this.getOptions(options);
            this.$container = this.$elem.closest('.inputs');
            this.name = this.$elem.attr('id');
            this.stringData = this.$elem.val();
            this.widgetstype = "ezdia.inputlist." + this.name;
            this.validateObj = {};
            this.inheritObj = {};
            this.validateUniqueObject = {};
            this.emptyRow = false;
            this.setMarkupTemplates();
            this.render();
        };
        InputList.prototype.render = function (refresh) {
            return __awaiter(this, void 0, void 0, function () {
                var options, mode, editable, data, row;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            options = this.options;
                            mode = options.mode.toLowerCase();
                            editable = options.editable;
                            data = getDataObject(this.stringData);
                            row = null;
                            validateKey = $.ezdia.config.validate_key;
                            if (!(mode === 'list')) return [3 /*break*/, 1];
                            row = this.createInputList(data);
                            return [3 /*break*/, 3];
                        case 1:
                            if (!(mode === 'group')) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.createGroupList(data)];
                        case 2:
                            row = _a.sent();
                            _a.label = 3;
                        case 3:
                            if (options.preview) {
                                this.$elem.val(row);
                            }
                            $(this.elem).wrap('').hide();
                            this.$elem.after(row);
                            if (!$.isEmptyObject(this.validateObj)) {
                                this.validateUniqueObject[this.name] = {};
                                this.validate();
                                this.inheritField();
                            }
                            if (mode === 'group') {
                                $.ezdia.widgets.create(this.widgetstype);
                            }
                            if (editable && !refresh) {
                                this.bindEvents();
                                $.ezdia.quickActionOpenProjectDefRule.actions();
                            }
                            this.rearrange();
                            return [2 /*return*/];
                    }
                });
            });
        };
        InputList.prototype.createInputList = function (dataProps) {
            var data = dataProps;
            var options = this.options;
            var editable = options.editable;
            var mode = options.mode.toLowerCase();
            var rows = this.template;
            this.emptyRow = true;
            if (data) {
                this.$elem.val(JSON.stringify(data));
            }
            if (!data) {
                data = [];
            }
            else if (!$.isArray(data)) {
                data = formatToArray(data);
            }
            return rows({
                name: this.name,
                mode: mode,
                editable: editable,
                rows: data
            });
        };
        InputList.prototype.createGroupList = function (rowData) {
            return __awaiter(this, void 0, void 0, function () {
                var self, _a, editable, mode, fields, _b, rearrange, isAddAndRemove, attrMeta, response, data, action, error_1, rows, dummyFieldArray;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            self = this;
                            _a = this.options, editable = _a.editable, mode = _a.mode, fields = _a.fields, _b = _a.config, rearrange = _b.rearrange, isAddAndRemove = _b.add_and_remove, attrMeta = _b.attr_meta;
                            if (!(attrMeta && rowData && rowData.length)) return [3 /*break*/, 4];
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            data = getAttrMetaReqData(attrMeta, rowData);
                            action = attrMeta.action;
                            return [4 /*yield*/, ezdia.Http.post({
                                    url: action,
                                    data: data
                                })];
                        case 2:
                            response = _c.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _c.sent();
                            return [3 /*break*/, 4];
                        case 4:
                            rows = [];
                            this.emptyRow = false;
                            dummyFieldArray = [];
                            $.ezdia.widgets.load(this.widgetstype);
                            if (rowData && rowData.length) {
                                if (editable) {
                                    $.each(rowData, function (i, data) {
                                        rows.push(createGroupRows.call(self, data, response, attrMeta));
                                    });
                                }
                                else {
                                    $.each(fields, function (i, fobj) {
                                        dummyFieldArray.push(fobj.name);
                                    });
                                    $.each(rowData, function (i, data) {
                                        var count = 0;
                                        var items = [];
                                        $.each(dummyFieldArray, function (j, fname) {
                                            var value = data[fname];
                                            if (value || value === 0 || value === false) {
                                                value = getFieldValue({
                                                    field: fields[count],
                                                    value: value,
                                                    count: i
                                                });
                                            }
                                            items.push({
                                                value: value
                                            });
                                            count += 1;
                                        });
                                        rows.push(items);
                                    });
                                }
                            }
                            else {
                                this.emptyRow = true;
                                rows.push(createGroupRows.call(this));
                            }
                            return [2 /*return*/, this.template({
                                    name: this.elem.name,
                                    mode: mode,
                                    editable: editable,
                                    rearrange: rearrange,
                                    isAddAndRemove: isAddAndRemove,
                                    rows: rows,
                                    label: getLabels(fields)
                                })];
                    }
                });
            });
        };
        InputList.prototype.bindEvents = function () {
            this.$container
                .on(this.options.trigger + "." + this.type, this.options.addBtnSelector, $.proxy(this.addRow, this))
                .on(this.options.trigger + "." + this.type, this.options.removeBtnSelector, $.proxy(this.removeRow, this))
                .on("change." + this.type, this.options.inputsSelector, $.proxy(this.update, this))
                .on("keyup." + this.type, this.options.inputsSelector, $.proxy(this.keyListener, this))
                .find(this.options.editBtnSelector)
                .on(this.options.trigger + "." + this.type, $.proxy(this.editRow, this));
            this.onOffAddBtn();
            this.onOffRemoveBtn();
        };
        InputList.prototype.rearrange = function () {
            var _this = this;
            var rearrange = this.options.config.rearrange;
            if (rearrange === false) {
                return;
            }
            var mode = this.options.mode.toLowerCase();
            if (mode === 'list') {
                var cls_1 = 'list-rearrange';
                var ul_1 = $("#ez-js-list-" + this.name);
                var rearrangeBtn = $("#ez-js-list-field-rearrange-" + this.name);
                var rearrangeDoneBtn = $("#ez-js-list-field-rearrange-done-" + this.name);
                rearrangeBtn.on('click', function () {
                    ul_1.addClass(cls_1);
                    ul_1.sortable({
                        items: 'li',
                        cursor: 'ns-resize'
                    });
                });
                rearrangeDoneBtn.on('click', function () {
                    ul_1.removeClass(cls_1);
                    ul_1.sortable('destroy');
                    _this.update();
                });
            }
            else {
                var elemName = this.elem.name;
                var cls_2 = 'group-input-items-list-rearrange';
                var table_1 = $("#ez-js-group-field-table-" + elemName);
                var tbody_1 = table_1.find('tbody');
                var rearrangeBtn = $("#ez-js-group-field-rearrange-" + elemName);
                var rearrangeDoneBtn = $("#ez-js-group-field-rearrange-done-" + elemName);
                rearrangeBtn.on('click', function () {
                    table_1.addClass(cls_2);
                    tbody_1.sortable({
                        items: 'tr',
                        cursor: 'ns-resize'
                    });
                });
                rearrangeDoneBtn.on('click', function () {
                    table_1.removeClass(cls_2);
                    tbody_1.sortable('destroy');
                    _this.update();
                });
            }
        };
        InputList.prototype.addRow = function (e) {
            var isAddAndRemove = this.options.config.add_and_remove;
            var elem = $(e.currentTarget);
            var parent = elem.closest(this.options.rowSelector);
            var mode = this.options.mode.toLowerCase();
            var template = this.rowTemplate;
            var row = null;
            this.validateObj = {};
            if (mode === 'list') {
                row = template({
                    mode: mode
                });
            }
            else {
                $.ezdia.form.init();
                var context = createGroupRows.call(this);
                row = template(context, isAddAndRemove);
            }
            parent.after(row);
            if (mode === 'group') {
                $.ezdia.widgets.create(this.widgetstype);
                this.validate();
                this.inheritField();
                this.isColumnsHidden(parent);
            }
            this.emptyRow = true;
            this.onOffAddBtn();
            this.onOffRemoveBtn();
        };
        InputList.prototype.isColumnsHidden = function (parent) {
            var hiddenTds = parent.find('td:not(:visible)');
            var currentRow = parent.next('tr');
            if (!hiddenTds.length) {
                return;
            }
            $.each(hiddenTds, function each() {
                var index = $(this).index();
                currentRow.find("td:eq(" + index + ")").hide();
            });
        };
        InputList.prototype.editRow = function (e) {
            var elem = $(e.currentTarget);
            var parent = elem.closest(this.options.rowSelector);
            var value = parent.find('[data-path]').val();
            var mode = this.options.mode.toLowerCase();
            var template = this.rowTemplate;
            var row = template({
                mode: mode,
                value: value,
                type: 'edit'
            });
            elem.off("." + this.type);
            elem.tooltip('destroy');
            parent.replaceWith(row);
        };
        InputList.prototype.removeRow = function (e) {
            var self = this;
            var elem = $(e.currentTarget);
            var parent = elem.closest(this.options.rowSelector);
            var listCount = parent.data('listCount');
            var validateNames = '';
            var mode = this.options.mode.toLowerCase();
            var type = null;
            if (mode === 'list') {
                type = parent.data('rowType');
                if (type === 'edit') {
                    var value = parent.find('[data-path]').val();
                    var row = this.rowTemplate({
                        mode: mode,
                        value: value,
                        type: 'remove'
                    });
                    parent.replaceWith(row);
                }
                else {
                    parent.remove();
                }
            }
            else {
                if (listCount || listCount === 0) {
                    validateNames = parent.data('valdiateNames') || '';
                    $.each(validateNames.split(','), function (i, name) {
                        self.updatevalidateUniqueArray(name, listCount || 0);
                    });
                }
                parent.remove();
            }
            this.update();
            this.onOffRemoveBtn();
            this.onOffAddBtn();
        };
        InputList.prototype.onOffAddBtn = function () {
            var allAddBtns = this.$container.find(this.options.addBtnSelector);
            if (!this.emptyRow) {
                var addBtns = allAddBtns.get().pop();
                $(addBtns).removeAttr('disabled');
            }
            else {
                allAddBtns.attr('disabled', 'disabled');
            }
        };
        InputList.prototype.onOffRemoveBtn = function () {
            var mode = this.options.mode.toLowerCase();
            var removeBtn = this.$container.find(this.options.removeBtnSelector);
            if (mode === 'list') {
                var length_1 = $("#ez-js-list-" + this.name).find('li').length;
                var btn = $("#ez-js-list-field-rearrange-" + this.name);
                if (length_1 > 1) {
                    btn.removeAttr('disabled');
                }
                else {
                    btn.attr('disabled', 'disabled');
                }
            }
            var rearrange = $("#ez-js-group-field-rearrange-" + this.name);
            if (removeBtn.length === 1) {
                removeBtn.attr('disabled', 'disabled');
                rearrange.attr('disabled', 'disabled');
            }
            else {
                removeBtn.removeAttr('disabled');
                rearrange.removeAttr('disabled');
            }
        };
        InputList.prototype.update = function () {
            var self = this;
            var rows = this.$container.find(this.options.rowSelector);
            var arr = [];
            var str = null;
            // this.emptyRow = false;
            $.each(rows, function eachrows() {
                var obj = self.getRowData($(this));
                var type = $(this).data('rowType');
                if (obj) {
                    arr.push(obj);
                }
                else if (!type && type !== 'remove') {
                    self.emptyRow = true;
                }
            });
            str = JSON.stringify(arr);
            $(this.elem).val(str).trigger('change').trigger('blur');
            this.onOffAddBtn();
            this.onOffRemoveBtn();
        };
        InputList.prototype.getRowData = function (row) {
            var options = this.options;
            var isData = false;
            var inputs = row.find(options.inputsSelector);
            var obj = {};
            $.each(inputs, function each() {
                var value = this.value;
                var name = $(this).data('path');
                name = name.split('__')[1] || 'value';
                if (value) {
                    isData = true;
                }
                obj[name] = value;
            });
            return isData ? obj : null;
        };
        InputList.prototype.keyListener = function (e) {
            var elem = $(e.currentTarget);
            var value = elem.val();
            if (value) {
                this.emptyRow = false;
            }
            else {
                this.emptyRow = true;
            }
            this.onOffAddBtn();
        };
        InputList.prototype.validate = function () {
            var self = this;
            var frm = this.$elem.closest('form');
            var isvalidator = frm.data('validator');
            if (!isvalidator) {
                $.ezdia.validate.create({}, frm, true);
            }
            $.each(this.validateObj, function (id, rulesObj) {
                var elem = $("[name=" + id + "]");
                elem.rules('add', rulesObj.validateRules);
                if (rulesObj.validateRules.unique) {
                    self.validateUnique(elem, rulesObj.inherit_from);
                }
            });
        };
        InputList.prototype.validateUnique = function (elem, name) {
            this.validateUniqueObject[this.name][name] =
                this.validateUniqueObject[this.name][name] || [];
            var self = this;
            var uniqueKeyObj = validateKey.unique;
            var validateUniqueArray = this.validateUniqueObject[this.name][name];
            var index = validateUniqueArray.length;
            var valdiateNames = '';
            var row = elem
                .data(uniqueKeyObj.index, index)
                .data(uniqueKeyObj.key, validateUniqueArray)
                .closest(this.options.rowSelector);
            row.data('list-count', index);
            valdiateNames = row.data('valdiateNames') || '';
            if (valdiateNames) {
                valdiateNames += "," + name;
            }
            else {
                valdiateNames = name;
            }
            row.data('valdiate-names', valdiateNames);
            validateUniqueArray.push(encodeURIComponent(elem.val()));
            elem
                .on('change', function change() {
                self.updatevalidateUniqueArray(this);
                elem.data('event', 'blur').valid();
                elem.data('event', '');
            })
                .data('name', name);
        };
        InputList.prototype.updatevalidateUniqueArray = function (elem, index) {
            var value = '';
            var name = '';
            if (index || index === 0) {
                name = elem;
            }
            else {
                value = encodeURIComponent(elem.value);
                var $elem = $(elem);
                // eslint-disable-next-line no-param-reassign
                index = $elem.data(validateKey.unique.index);
                name = $elem.data('name');
            }
            if (name) {
                this.validateUniqueObject[this.name][name][index] = value;
            }
        };
        InputList.prototype.inheritField = function () {
            if ($.isEmptyObject(this.inheritObj)) {
                return;
            }
            $.each(this.inheritObj, function (count, col) {
                if (col.inherit.from) {
                    var id = col.inherit.from.replace(/\./g, '_');
                    id += count;
                    $("[name=" + id + "]").on('change', function change() {
                        changeInput.call(this, this, col);
                    });
                }
            });
        };
        return InputList;
    }());
    // PRIVATE FUNCTIONS
    // =========================
    var getDataObject = function (str) {
        if (!str) {
            return null;
        }
        return $.ezdia.getJsonObject(str);
    };
    var formatToArray = function (data) {
        var arr = [];
        $.each(data, function (i, value) {
            arr.push({
                value: value
            });
        });
        return arr;
    };
    var getLabels = function (fields) {
        var arr = [];
        fields.forEach(function (_a) {
            var label = _a.label, name = _a.name, edittype = _a.edittype;
            if (edittype !== 'hidden') {
                arr.push({
                    label: label,
                    name: name
                });
            }
        });
        return arr;
    };
    var getFieldValue = function (obj) {
        var field = obj.field;
        var column = $.extend({}, obj.field, {
            editable: false,
            id: field.name + obj.count,
            name: field.name + obj.count
        });
        var value = obj.value;
        var config = field.config || {};
        var urlObj = {};
        if (field.edittype === 'singlechoice' && !config.userInput) {
            // eslint-disable-next-line consistent-return
            $.each(field.config.options, function (key, mval) {
                if (key === value) {
                    value = mval;
                    return false;
                }
            });
        }
        else if (field.edittype === 'url') {
            value = $.ezdia.url.init(urlObj, {
                column: column,
                value: obj.value
            });
            setTimeout(function () {
                $.ezdia.url.create(urlObj);
            }, 0);
        }
        else {
            value = $.ezdia.inputs.readonlyView({
                column: column,
                value: obj.value
            });
            if (column.entity && typeof column.entity === 'string') {
                column.entity = $.ezdia.getJsonObject(column.entity);
            }
            if (column.entity && column.entity.viewAccess) {
                value = "<div data-row=\"row\"><div data-row=\"input\" id=\"" + (column.id || column.name) + "\">" + value + "</div></div>";
            }
        }
        return value;
    };
    function createGroupRows(data, metaData, attrMeta) {
        var self = this;
        var options = self.options;
        var context = null;
        var arr = [];
        var attrMetaFor = attrMeta === null || attrMeta === void 0 ? void 0 : attrMeta.for;
        var _a = __read((attrMeta === null || attrMeta === void 0 ? void 0 : attrMeta.query) || [], 1), attrMetaQuery = _a[0];
        if (!data) {
            $.ezdia.widgets.load(self.widgetstype);
        }
        options.fields.forEach(function (column) {
            var _a = column, name = _a.name, editable = _a.editable, columnConfig = _a.config;
            var oldedittype;
            var view = '';
            var obj;
            var value = data ? data[name] : '';
            var config = {};
            var validateRules = null;
            column.id = self.name + "_" + column.name + self.options.count;
            if (columnConfig) {
                config = updateComputeConfig.call(self, columnConfig);
            }
            // eslint-disable-next-line prefer-const
            obj = {
                column: $.extend(true, {}, column, {
                    name: column.id,
                    path: "groupFields__" + name,
                    config: config
                }),
                value: value
            };
            if (!editable) {
                view = $.ezdia.inputs.readonlyView(obj) || '';
                obj.column.edittype = 'hidden';
            }
            else {
                var attrMetaConfig = void 0;
                validateRules = column.validate_rules || config.validate_rules || null;
                if (validateRules) {
                    self.validateObj[column.id] = {
                        validateRules: validateRules,
                        inherit_from: column.name
                    };
                }
                if (column.inherit) {
                    self.inheritObj[self.options.count] = $.extend({}, {}, column);
                }
                if (attrMetaFor && attrMetaFor === name) {
                    var attrMetaQueryValue = data[attrMetaQuery];
                    attrMetaConfig = metaData[attrMetaQueryValue];
                }
                if (attrMetaConfig) {
                    var metaConfig = attrMetaConfig.config, metaedittype = attrMetaConfig.edittype;
                    oldedittype = obj.column.edittype;
                    var oldconfig = obj.column.config;
                    obj.column.config = __assign(__assign({}, oldconfig), metaConfig);
                    obj.column.config.options = __assign({ '--': '--' }, obj.column.config.options);
                    if (metaedittype === 'SINGLECHOICE_NON_EDITABLE') {
                        obj.column.edittype = 'singlechoice';
                        obj.column.config.userInput = false;
                    }
                    else {
                        obj.column.edittype = 'group';
                        obj.column.config.url = '';
                        obj.column.config.urlParam = '';
                    }
                }
                $.ezdia.widgets.init(obj, self.widgetstype);
            }
            context = $.ezdia.inputs.create(obj) + view;
            arr.push({
                fields: context,
                name: column.name,
                edittype: column.edittype
            });
            if (oldedittype) {
                column.edittype = oldedittype;
            }
        });
        this.options.count += 1;
        return arr;
    }
    function updateComputeConfig(config) {
        var _this = this;
        var configObj = $.extend(true, {}, config);
        var options = this.options;
        if (configObj.urlParam) {
            $.each(configObj.urlParam.reference, function (i, obj) {
                var name = '';
                if (obj.name.includes('.')) {
                    // eslint-disable-next-line prefer-destructuring
                    name = obj.name.split('.')[1];
                    obj.name = _this.name + "_" + name + options.count;
                }
            });
        }
        if (configObj.compute && configObj.compute.reference) {
            $.each(configObj.compute.reference, function (i, aval) {
                var name = '';
                if (aval.includes('.')) {
                    // eslint-disable-next-line prefer-destructuring
                    name = aval.split('.')[1];
                    configObj.compute.reference[i] = _this.name + "_" + name + options.count;
                }
            });
        }
        return configObj;
    }
    function changeInput(field, col) {
        var inheritObj = $(field).data('inherit-obj');
        if (!inheritObj) {
            return;
        }
        var to = $("#" + col.id);
        var toVal = to.val();
        var parent = to.closest('[data-row="input"]').empty();
        var obj = {
            column: $.extend({}, col, inheritObj),
            value: toVal
        };
        $.ezdia.widgets.load(this.widgetstype);
        $.ezdia.widgets.init(obj, this.widgetstype);
        var context = $.ezdia.inputs.create(obj);
        parent.append(context);
        $.ezdia.widgets.create(this.widgetstype);
    }
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */
    var publicMethods = {
        //  getValue: InputList.prototype.getValue,
        refresh: InputList.prototype.refresh,
        destroy: InputList.prototype.destroy
    };
    function jQueryInterface(option) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (typeof option === 'string' && option !== 'destroy') {
            return invokePublicMethod.call(this, option, args);
        }
        return createNewInstance.call(this, option);
    }
    function invokePublicMethod(methodName, args) {
        if (publicMethods[methodName]) {
            var inputObject = retrieveObjectFromElement(this);
            var result = publicMethods[methodName].apply(inputObject, args);
            if (typeof result === 'undefined') {
                return $(this);
            }
            return result;
        }
        throw new Error("method '" + methodName + "()' does not exist for input list.");
    }
    // eslint-disable-next-line consistent-return
    function retrieveObjectFromElement(element) {
        var inputObject = $(element).data(DATA_TYPE);
        if (inputObject && inputObject instanceof InputList) {
            return inputObject;
        }
    }
    function createNewInstance(option) {
        var $this = $(this);
        $this.each(function each() {
            var self = $(this);
            var data = self.data(DATA_TYPE);
            var options = typeof option === 'object' && option;
            if (!data) {
                self.data(DATA_TYPE, (data = new InputList(this, options)));
            }
            if (typeof option === 'string') {
                data[option]();
            }
        });
        return $this;
    }
    $.fn[NAME] = jQueryInterface;
    $.fn[NAME].Constructor = InputList;
    $.fn[NAME].noConflict = function noConflict() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return jQueryInterface;
    };
})(ezdia || (ezdia = {}));
